export function useJustificationTypes() {
  const LEAD_SCHEDULING_CANCEL = "lead_scheduling_cancel";
  const LEAD_SCHEDULING_REFUSE = "lead_scheduling_refuse";

  return {
    LEAD_SCHEDULING_CANCEL,
    LEAD_SCHEDULING_REFUSE,
  };
}
